module.exports = __webpack_public_path__ + "img/19.f14fd189.gif";